import COLORS from '@/constants/colors';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box, Button, Menu, MenuItem, Stack } from '@mui/material';
import { useDetailActionsViewController } from './DetailActionsViewController';

export function DetailActions() {
  const { uiState, actions, references } = useDetailActionsViewController();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        gap: '15px',
        alignItems: 'center',
        justifyContent: 'flex-end',
        width: { xs: '100%', sm: 'auto' },
      }}
    >
      {uiState.acceptOrderButton && (
        <Button
          variant="contained"
          onClick={actions.onClickedAcceptOrder}
          disabled={uiState.acceptOrderButton.disabled}
          startIcon={uiState.acceptOrderButton.leftIcon}
          sx={{
            backgroundColor: COLORS.olive,
            color: COLORS.white,
            borderRadius: '8px',
            fontSize: '14px',
            padding: '8px 16px',
            width: { xs: '100%', sm: 'auto' },
          }}
        >
          {uiState.acceptOrderButton.label}
        </Button>
      )}
      {uiState.deliveredOrderButton && (
        <Stack
          sx={{
            width: { xs: '100%', sm: 'auto' },
          }}
        >
          <Button
            variant="contained"
            onClick={actions.onClickedMarkAsDelivered}
            disabled={uiState.deliveredOrderButton.disabled}
            startIcon={uiState.deliveredOrderButton.leftIcon}
            sx={{
              backgroundColor: COLORS.purple_light,
              color: COLORS.blackish,
              borderRadius: '8px',
              fontSize: '14px',
              padding: '8px 16px',
            }}
          >
            {uiState.deliveredOrderButton.label}
          </Button>
        </Stack>
      )}
      <Box
        sx={{
          width: { xs: '100%', sm: 'auto' },
        }}
      >
        <Button
          variant="outlined"
          onClick={actions.handleMenuClick}
          sx={{
            borderRadius: '8px',
            fontSize: '14px',
            borderColor: COLORS.gray_200,
            color: COLORS.white,
            width: { xs: '100%', sm: 'auto' },
          }}
          endIcon={<MoreVertIcon />}
        >
          Más Acciones
        </Button>
        <Menu
          anchorEl={references.anchorEl}
          open={uiState.openMenu}
          onClose={actions.handleMenuClose}
        >
          <MenuItem onClick={actions.onClickedExportOrder}>
            Exportar pedido en xlsx
          </MenuItem>
          {uiState.showSendOrder && (
            <MenuItem onClick={actions.onClickedSendWhatsapp}>
              Enviar whatsapp de pedido
            </MenuItem>
          )}
          {uiState.showCancelOrder && (
            <MenuItem onClick={actions.onClickedCancelOrder}>
              Cancelar pedido
            </MenuItem>
          )}
          {uiState.showViewHistory && (
            <MenuItem onClick={actions.onClickedShowHistory}>
              Ver historial
            </MenuItem>
          )}
        </Menu>
      </Box>
    </Box>
  );
}
